import { render, staticRenderFns } from "./MainLedgerIndexVAT.vue?vue&type=template&id=14a48738&scoped=true"
import script from "./MainLedgerIndexVAT.vue?vue&type=script&lang=js"
export * from "./MainLedgerIndexVAT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a48738",
  null
  
)

export default component.exports